import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

const ROUND_SIZE: number = 300;

@Component({
  selector: 'app-round',
  templateUrl: './round.component.html',
  styleUrls: ['./round.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RoundComponent implements OnInit {
  @ViewChild('videoElement') videoElement!: ElementRef;
  @Input() url: string | undefined;
  @Input() duration: string | number | undefined;
  @Input() isLoading: boolean | undefined = false;
  @Output() onLoadRound = new EventEmitter();
  protected isSound: boolean = false;
  protected isActive = false;
  protected progress = 0;
  protected remainingDuration!: string | number | undefined;

  ngOnInit() {
    this.remainingDuration = this.duration;
  }

  protected loadRound() {
    this.onLoadRound.emit();
  }

  protected togglePlayPause(): void {
    const video: HTMLVideoElement = this.videoElement.nativeElement;

    if (video.paused || !this.isActive) video.play();
    else video.pause();

    this.isSound = !video.paused;

    if (!this.isActive) {
      this.isActive = true;
      video.currentTime = 0;
      this.videoElement.nativeElement.addEventListener('timeupdate', this.updateProgress);
    }
  }

  protected updateProgress = () => {
    if (this.videoElement) {
      const video: HTMLVideoElement = this.videoElement.nativeElement;
      this.progress = (video.currentTime / video.duration) * 100;
      this.remainingDuration = video.duration - video.currentTime;
    }
  };

  protected onVideoEnded() {
    const video: HTMLVideoElement = this.videoElement.nativeElement;
    video.currentTime = 0;
    video.play();
    this.progress = 0;
    this.remainingDuration = this.duration;
    this.isActive = false;
    this.isSound = false;
    this.videoElement.nativeElement.removeEventListener('timeupdate', this.updateProgress);
  }

  protected readonly ROUND_SIZE = ROUND_SIZE;
  protected readonly Math = Math;
}
